import React from 'react';
import App from './App.jsx';
import { useAuth } from './contexts/AuthContext';

const AuthGate = () => {
  const auth = useAuth();
  const isLoading = auth ? auth.isLoading : false;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050914] px-4 text-sm text-slate-300">
        <div className="rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-4">
          Loading Vision workspace...
        </div>
      </div>
    );
  }

  return <App />;
};

export default AuthGate;
